import {
    getCertificates,
    deleteCertifications,
    restoreCertificate,
    getArchive,
    purchaseID06,
    exportSsg,
} from '../../Api/ApiCertificate';

import {
    today,
    in3months,
    inMonths,
    processCertificatesArray,
    setSelectedStorage,
    removeSelectedStorage,
    setSnackbar,
} from '@/helpers.js';

const filterDefaultState = () => {
    return {
        key: 'filterAll',
        showArchive: false,
        dateFrom: null,
        dateTo: null,
        outgoingMonths: 3,
    };
};

const initialState = () => ({
    loading: true,
    selected_all: 'none',
    selected: {
        data: [],
    },
    filter: filterDefaultState(),
    certificates: [],
    certificatesShow: [],
    newCreated: [],
    quantityOfOutgoing: 0,
    quantityOfExpired: 0,
    showArchive: false,
    searchWord: '',
    newlyAdded: {
        total: null,
    },
    userDetails: {
        show: false,
        client: false,
        id: null,
    },
    sortOrder: 'ASC',
    response: {},
});

const state = initialState();

const mutations = {
    SET_LOADING: (state, bool) => (state.loading = bool),
    SET_NEW_CREATED: (state, arr) => (state.newCreated = arr),
    SET_SORTED_CERTIFICATES: (state, sorted) => (state.certificatesShow = sorted),
    SET_CERTIFICATES_ALL: (state, cert) => state.certificatesShow.push(cert),
    SET_NEWLY_ADDED: (state, obj) => (state.newlyAdded.total = obj.total),
    SET_SEARCH_RESULT: (state, array) => (state.certificatesShow = array),
    SET_RESPONSE: (state, obj) => (state.response = obj),
    SET_SORT_ORDER: (state, order = null) =>
        (state.sortOrder = order ? order.toUpperCase() : state.sortOrder === 'ASC' ? 'DESC' : 'ASC'),
    SET_OUTGOING: (state) =>
        (state.quantityOfOutgoing = state.certificates.filter(
            (c) => c.expires_at <= in3months() && c.expires_at > today
        ).length),
    SET_EXPIRED: (state) => (state.quantityOfExpired = state.certificates.filter((c) => c.expires_at < today).length),
    SET_SEARCHWORD: (state, string) => (state.searchWord = string),
    UPDATE_CERTIFICATES(state, obj) {
        obj.certificates.forEach((cert) => {
            let obj = state.certificates.find((obj) => obj.id === cert.id);
            obj = cert;
        });
        // Reset selected_all
        state.selected_all = 'none';
    },
    SET_CERTIFICATES(state, obj) {
        state.certificates = obj.certificates;
        state.certificatesShow = obj.show;

        // Reset selected_all
        state.selected_all = 'none';
    },
    UPDATE_FIELD(state, field) {
        const obj = state.certificates.find((obj) => obj.id === field.id);
        obj[field.key] = field.value;
    },
    SET_SELECTED_ALL(state, itemIds = []) {
        if (state.selected_all === 'few' || state.selected_all === 'all') {
            state.selected_all = 'none';
            state.certificatesShow.forEach((item) => (item.selected = false));
            return;
        }

        state.selected_all = 'all';

        if (itemIds.length > 0) {
            state.certificatesShow.forEach((item) => {
                if (itemIds.includes(item.id)) {
                    item.selected = true;
                }
            });
        } else {
            state.certificatesShow.forEach((item) => (item.selected = true));
        }
    },
    SET_SELECTED_TOGGLER(state, id) {
        let certLength = state.certificates.length;

        const hasSorted = state.userDetails && state.userDetails.name;
        const obj = state.certificates.find((obj) => obj.id === id);

        obj.selected = !obj.selected;

        const selectedCount = state.certificates.filter((i) => i.selected === true).length;

        if (hasSorted) {
            certLength = state.certificates.filter(
                (c) => c[state.userDetails.client ? 'client' : 'user'].id === state.userDetails.id
            ).length;
        }

        if (certLength === selectedCount) {
            state.selected_all = 'all';
        } else if (selectedCount === 0) {
            state.selected_all = 'none';
        } else {
            state.selected_all = 'few';
        }
    },
    SET_ONLY_SELECTED(state, id) {
        const obj = state.certificates.find((obj) => obj.id === id);
        state.certificates.forEach((c) => (c.selected = false));

        obj.selected = true;
        state.selected_all = 'few';
    },
    SET_USER_DETAILS(state, obj) {
        if (obj !== null) {
            const target =
                obj.type === 'user'
                    ? state.certificates.find((c) => c.user.id === obj.id).user
                    : state.certificates.find((c) => c.client.id === obj.id).client;
            const certs =
                obj.type === 'user'
                    ? state.certificatesShow.filter((c) => c.user.id === obj.id)
                    : state.certificatesShow.filter((c) => c.client.id === obj.id);

            if (target) {
                state.userDetails.show = true;
                state.userDetails.client = obj.type !== 'user';
                state.userDetails.id = obj.id;
                state.userDetails.name = obj.type === 'user' ? `${target.first_name} ${target.last_name}` : target.name;
                state.userDetails.ssn = obj.type === 'user' ? '' : target.organization_number;
                state.userDetails.cert_email = [target.email];
                state.userDetails.phone_number = target.phone_number;

                state.certificatesShow = certs;

                // certs.map((c) => !state.userDetails.cert_email.includes(c.email) ? state.userDetails.cert_email.push(c.email) : null)
            }
        } else {
            state.userDetails.show = false;
            state.userDetails.client = false;
            state.userDetails.id = null;
            state.userDetails.name = '';
            state.userDetails.ssn = '';
            state.userDetails.email = '';
            state.userDetails.phone_number = '';

            if (state.searchWord === '') {
                state.certificatesShow = state.certificates;
            }
        }
    },
    SET_SHOW_ARCHIVE(state, bool) {
        state.showArchive = bool;
    },
    FILTER_DATES(state, field) {
        const key = Object.keys(field);
        state[key] = field[key];
    },
    SET_SELECTED(state) {
        const filterCertificate = state.certificates.filter((c) => c.selected === true);

        if (filterCertificate.length > 0) {
            const clone = [...filterCertificate];
            // Save as cache
            setSelectedStorage(clone);
        }
    },
    CLEAR_SELECTED(state) {
        state.selected = [];
        // Remove cache
        removeSelectedStorage();
    },
    CLEAR_FILTER: (state) => Object.assign(state.filter, filterDefaultState()),
    CLEAR_USERDETAILS(state) {
        state.userDetails = {
            show: false,
            client: false,
            id: null,
        };
    },
    SET_FILTER: (state, filter) => {
        const key = Object.keys(filter)[0];

        if (state.filter.key === filter.key) return;
        key === 'dateFrom' || key === 'dateTo' || key === 'showArchive'
            ? (state.filter[key] = filter[key])
            : (state.filter.key = filter.key);
    },
    SET_FILTER_OUTGOING: (state, months) => {
        state.filter.outgoingMonths = months;
    },

    RESET_STATE: (state) => Object.assign(state, initialState()),
};

const actions = {
    GET_CERTIFICATES: async ({ commit, state }, filter = {}) => {
        await getCertificates(filter).then((response) => {
            if (response.status === 'Success') {
                let certs = processCertificatesArray(response.data, state.newCreated);

                commit('SET_CERTIFICATES', certs);
                commit('SET_OUTGOING');
                commit('SET_EXPIRED');
                commit('SET_LOADING', false);
            }
        });
    },
    GET_ARCHIVE: async ({ commit }) => {
        await getArchive().then((response) => {
            if (response.status === 'Success') {
                commit('SET_CERTIFICATES', processCertificatesArray(response.data, []));
            }
        });
    },
    DELETE_CERTIFICATIONS: async ({ state, commit, dispatch }, method) => {
        const selected = state.certificates.filter((c) => c.selected === true);

        return await deleteCertifications({
            method: method,
            certificates: selected.map((c) => c.id),
        }).then((response) => {
            if (response.status === 'Error') {
                return;
            }

            const snackbar = setSnackbar(response);

            commit('CLEAR_USERDETAILS');

            window.dispatchEvent(new CustomEvent('statistics.update.data'));
            dispatch('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

            /**
             * Removed since API v2
             */
            // dispatch('GET_CERTIFICATES', state.filter.showArchive ? { archive: true } : {});
        });
    },
    RESTORE_CERTIFICATION: async ({ dispatch }) => {
        const selected = state.certificates.filter((c) => c.selected === true);

        return await restoreCertificate({
            certificates: selected.map((c) => c.id),
        }).then((response) => {
            if (response.status === 'Success') {
                const snackbar = setSnackbar(response);

                window.dispatchEvent(new CustomEvent('statistics.update.data'));
                dispatch('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

                /**
                 * Removed since API v2
                 */
                // dispatch('GET_CERTIFICATES', { archive: true });
            }
        });
    },
    PURCHASE_ID06: async ({ commit, dispatch }, payload) => {
        await purchaseID06({ certificates: payload }).then((response) => {
            if (response.status === 'Success') {
                let certs = processCertificatesArray(response.data, []);
                commit('SET_CERTIFICATES', certs);
            }

            dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(response), { root: true });
        });
    },
    EXPORT_SSG: async ({ commit, dispatch }, payload) => {
        await exportSsg({ certificates: payload }).then((response) => {
            if (response.status === 'Success') {
                let certs = processCertificatesArray(response.data, []);
                commit('UPDATE_CERTIFICATES', certs);
            }

            dispatch('GlobalStore/SET_SNACKBAR', setSnackbar(response), { root: true });
        });
    },
    SORT_ARRAY: ({ commit, state }, field) => {
        let sorted = [];
        let clone = [...state.certificatesShow];

        commit('SET_SORT_ORDER');

        const asc = state.sortOrder.toLowerCase() === 'asc';

        const dateSorter = (a, b) => {
            // equal items sort equally
            if (a.expires_at === b.expires_at) {
                return 0;
            }

            // nulls sort after anything else
            if (a.expires_at === null) {
                return asc ? 1 : -1;
            }
            if (b.expires_at === null) {
                return asc ? -1 : 1;
            }

            // otherwise, if we're ascending, the lowest sorts first
            if (asc) {
                return a.expires_at < b.expires_at ? -1 : 1;
            }

            // if descending, the highest sorts first
            return a.expires_at < b.expires_at ? 1 : -1;
        };

        if (field === 'name') {
            sorted = asc
                ? clone.sort((a, b) => b.first_name.localeCompare(a.first_name))
                : clone.sort((a, b) => a.first_name.localeCompare(b.first_name));
        } else if (field === 'competence') {
            sorted = asc
                ? clone.sort((a, b) => b.competence.name.localeCompare(a.competence.name))
                : clone.sort((a, b) => a.competence.name.localeCompare(b.competence.name));
        } else if (field === 'client') {
            sorted = asc
                ? clone.sort((a, b) => b.client?.name.localeCompare(a.client?.name))
                : clone.sort((a, b) => a.client?.name.localeCompare(b.client?.name));
        } else if (field === 'expires_at') {
            sorted = clone.sort(dateSorter);
        } else if (field === 'certifier') {
            sorted = asc
                ? clone.sort((a, b) => b.certificate_meta?.name.localeCompare(a.certificate_meta?.name))
                : clone.sort((a, b) => a.certificate_meta?.name.localeCompare(b.certificate_meta?.name));
        } else if (field === 'external_issuer') {
            sorted = asc
                ? clone.sort((a, b) => b.meta?.external_issuer?.localeCompare(a.meta?.external_issuer))
                : clone.sort((a, b) => a.meta?.external_issuer?.localeCompare(b.meta?.external_issuer));
        } else if (field === 'latest') {
            sorted = asc
                ? clone.sort((a, b) => a.issued_at.localeCompare(b.issued_at))
                : clone.sort((a, b) => b.issued_at.localeCompare(a.issued_at));
        }

        commit('SET_SORTED_CERTIFICATES', sorted);
    },
    SHOW_ALL: ({ commit, state }) => {
        state.certificates.forEach((cert) => {
            if (!state.certificatesShow.includes(cert)) {
                commit('SET_CERTIFICATES_ALL', cert);
            }
        });
    },
    SEARCH: (
        { commit, dispatch, state },
        searchKeys = [
            'certificate.competence.name',
            'certificate.client.name',
            ['certificate.user.first_name', 'certificate.user.last_name'],
        ]
    ) => {
        let result = [];

        if (state.searchWord !== '') {
            const s = state.searchWord.toLowerCase();

            searchKeys.forEach((key) => {
                if (Array.isArray(key)) {
                    const combinedKeys = key.map((k) => k.replace(/([^.]*)./, '')); //removes everything before first dot + .
                    const combinedCertificates = state.certificates.filter((certificate) => {
                        const combinedSearchRow = combinedKeys
                            .map((k) => k.split('.').reduce((obj, i) => (obj[i] ? obj[i] : ''), certificate))
                            .join(' ')
                            .toLowerCase();
                        return combinedSearchRow.includes(s);
                    });
                    result = [...result, ...combinedCertificates];
                    return;
                }

                const expression = key.replace(/([^.]*)./, ''); //removes everything before first dot + .

                result = [
                    ...result,
                    ...state.certificates.filter((certificate) => {
                        const searchRow = expression
                            .split('.')
                            .reduce((obj, i) => (obj[i] ? obj[i] : false), certificate);
                        if (!searchRow) return false;
                        // Make sure we're not already in the result array
                        if (result.some((e) => e.id === certificate.id)) return false;
                        return searchRow.toLowerCase().includes(s);
                    }),
                ];
            });

            commit('SET_SEARCH_RESULT', result);
        } else {
            dispatch('DO_FILTER');
        }
    },
    SEARCH_USER_CERTIFICATES: ({ commit, dispatch, state }, searchKeys) => {
        if (state.searchWord !== '') {
            const s = state.searchWord;

            let result = [];

            searchKeys.forEach((key) => {
                const expression = key.replace(/([^.]*)./, ''); //removes everything before first dot + .
                result = [
                    ...result,
                    ...state.certificates.filter(
                        (cert) => expression.split('.').reduce((obj, i) => (obj[i] ? obj[i] : false), cert) === s
                    ),
                ];
            });

            commit('SET_SEARCH_RESULT', result);
        } else {
            dispatch('DO_FILTER');
        }
    },
    SET_FILTER: async ({ dispatch }) => {
        await dispatch('DO_FILTER');
    },
    DO_FILTER: async ({ state, commit }) => {
        let results = [];

        state.certificates.forEach((item) => {
            if (state.filter.key === 'filterAll') {
                results.push(item);
            }

            if (state.filter.key === 'filterValid') {
                //prettier-ignore
                if(
                    item.expires_at <= inMonths(state.filter.outgoingMonths) && item.expires_at < today ||
                    (item.expires_at <= inMonths(state.filter.outgoingMonths) && item.expires_at > today)
                ) {
                    return;
                }

                results.push(item);
            }

            if (state.filter.key === 'filterOutgoing') {
                if (item.expires_at <= inMonths(3) && item.expires_at > today) {
                    results.push(item);
                }
            }

            if (state.filter.key === 'filterCustomOutgoing') {
                if (item.expires_at <= inMonths(state.filter.outgoingMonths) && item.expires_at > today) {
                    results.push(item);
                }
            }

            if (state.filter.key === 'filterExpired') {
                if (item.expires_at <= inMonths(state.filter.outgoingMonths) && item.expires_at < today) {
                    results.push(item);
                }
            }
        });

        // Date filter
        if (state.filter.dateFrom && !state.filter.dateTo) {
            // Only from selected
            results = results.filter((i) => i.expires_at >= state.filter.dateFrom);
        }

        if (!state.filter.dateFrom && state.filter.dateTo) {
            // Only to selected
            results = results.filter((i) => i.expires_at <= state.filter.dateTo);
        }

        if (state.filter.dateFrom && state.filter.dateTo) {
            // Both
            results = results.filter(
                (i) => i.expires_at >= state.filter.dateFrom && i.expires_at <= state.filter.dateTo
            );
        }

        await commit('SET_SEARCH_RESULT', results);
    },
};

const getters = {
    isLoading: (state) => state.loading,
    totalCertificates: (state) => state.certificates.length,
    certificatesShow: (state) => state.certificatesShow,
    GET_OUTGOING_MONTHS: (state) => state.filter.outgoingMonths,
    GET_SHOW_ARCHIVE: (state) => state.showArchive,
    GET_SORT_ORDER: (state) => state.sortOrder,
    GET_SELECTED_ALL: (state) => state.selected_all,
    GET_USER_DETAILS: (state) => state.userDetails,
    GET_QUANTITY_OUTGOING: (state) => state.quantityOfOutgoing,
    GET_QUANTITY_EXPIRED: (state) => state.quantityOfExpired,
    GET_SEARCHWORD: (state) => state.searchWord,
    GET_SELECTED_CERTS: (state) => state.certificates.filter((i) => i.selected === true),
    GET_NEW_CREATED: (state) => state.newCreated,
    GET_FIELD: (state) => (id, key) => state.certificates?.find((i) => i?.id === id)?.[key],
    GET_FILTER_KEY: (state) => state.filter.key,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
